<template>
  <div class="my_dy">
    <div v-if="!isWx" class="head flex align-center justify-bet">
      <i @click="goBack" class="back"></i>
      <span class="title">我的订阅</span>
      <div class="btn flex justify-center align-center">
        <i></i>
        <span @click="jumpDown">订阅</span>
      </div>
    </div>
    <!-- 列表 -->
    <div class="listBox" :style="{ 'padding-top': isWx ? '0' : '60px' }">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="initListData"
        :immediate-check="true"
      >
        <van-cell v-for="item in listData" :key="item.id">
          <div class="item flex align-center">
            <img :src="item.image" alt="" />
            <div class="info flex_1">
              <span>{{ item.name }}</span>
              <p class="van-ellipsis">{{ item.show_txt }}</p>
            </div>
            <span class="btn" @click="jumpDown">订阅</span>
          </div>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getMyDy } from "@/request/api";
import Contents from "@/request/base.default.js";
import { getCookie, navigate, checkWx } from "@/pages/index/custom";

export default {
  data() {
    return {
      // 最新发布
      listData: [],
      listPage: 1,
      loading: false, // 加载中
      finished: false, // 加载完毕
      isWx: true,
    };
  },
  methods: {
    // 最细发布
    initListData() {
      getMyDy({
        page: this.listPage,
        pcount: 10,
      })
        .then((res) => {
          let { data, error_code } = res;
          if (error_code === 0) {
            if (!data || data.length === 0) {
              this.finished = true;
              this.loading = false;
              return false;
            }
            data.map((item) => this.listData.push(item));
            this.listPage++;
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    jumpDown() {
      if (checkWx()) {
        navigate("", Contents.downURL + "?mini=1");
      } else {
        navigate("", Contents.downURL);
      }
    },
  },
  created() {
    this.isWx = checkWx();
    this.sessionid = getCookie(Contents.cookie_key);
    if (this.sessionid) {
      this.initListData();
    } else {
      navigate(
        "",
        Contents.mainURL +
          "/app/user/login?backURL=" +
          encodeURIComponent(window.location.href)
      );
    }
  },
};
</script>

<style lang="less" scoped>
.listBox {
  box-sizing: border-box;
  padding: 0 20px 60px 20px;
  .item {
    padding: 16px 0;
    border-bottom: 1px solid #eee;
    img {
      width: 3rem;
      height: 3rem;
      border-radius: 50%;
      overflow: hidden;
      object-fit: cover;
    }
    .info {
      padding: 0 8px;
      span {
        font-size: 16px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
      }
      p {
        font-size: 12px;
        font-weight: 400;
        color: rgba(167, 167, 167, 1);
        margin-top: 4px;
      }
    }
    .btn {
      width: 68px;
      height: 32px;
      background: rgba(255, 237, 239, 1);
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 76, 103, 1);
      border-radius: 100px;
    }
  }
}
.head {
  position: fixed;
  top: 0;
  height: 0;
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  padding: 0 20px;
  .title {
    font-size: 18px;
    font-weight: 500;
    color: rgba(34, 34, 34, 1);
  }
  .back {
    width: 1.5rem;
    height: 1.5rem;
    background: url(./images/icon_back_black.png) no-repeat;
    background-size: 100% 100%;
  }
  .btn {
    width: 68px;
    height: 32px;
    line-height: 32px;
    background: linear-gradient(
      135deg,
      rgba(255, 123, 154, 1) 0%,
      rgba(255, 21, 68, 1) 100%
    );
    border-radius: 100px;
    i {
      width: 1rem;
      height: 16px;
      background: url(./images/guanzhu.png) no-repeat;
      background-size: 100% 100%;
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>